import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavigationService } from '../../services/navigation/navigation.service';
import { CacheService } from '../../services/cache/cache.service';
import { CommonService } from '../../services/common/common.service';
import { Column } from '../interfaces/column.interface';
import moment from 'moment';
import { GiftsDataService } from './gifts-data.service';
import { Gift, GiftsResult } from '../interfaces';
import { MembersDataService } from './members-data.service';
import { Member, MembersResult } from '../interfaces';
import { User, UsersResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class ActivitiesColumnsService {

  public activities: Gift[] = [];
  public members: Member[] = [];
  public users: User[] = [];
  public gifts: Gift[]=[];

  constructor(
    private translate: TranslateService,
    private navigation: NavigationService

  ) {
  }


  getColumns(): Column[] {
    return [
      { field: 'phoneNumber', sortField: 'title', title: this.translate.instant('CONTENT.PHONENUMBER'), show: (this.navigation.getParamValue('posts.phoneNumber.showFiled', true) && true), displayInList: true, type: 'textValue' },
      { field: 'startTime', sortField: 'title', title: this.translate.instant('CONTENT.STARTDATE'), show: (this.navigation.getParamValue('posts.startTime.showFiled', true) && true), displayInList: true, type: 'textValue' },
      { field: 'validSteps', sortField: 'title', title: this.translate.instant('CONTENT.STEPS'), show: (this.navigation.getParamValue('posts.validSteps.showFiled', true) && true), displayInList: true, type: 'textValue' },
      { field: 'validDistance', sortField: 'title', title: this.translate.instant('CONTENT.DISTANCE'), show: (this.navigation.getParamValue('posts.distance.showFiled', true) && true), displayInList: true, type: 'textValue' },
      { field: 'duration', sortField: 'title', title: this.translate.instant('CONTENT.DURATION'), show: (this.navigation.getParamValue('posts.duration.showFiled', true) && true), displayInList: true, type: 'textValue' },
      { field: 'dailyAchievedNumberOfPoints', sortField: 'title', title: this.translate.instant('CONTENT.POINTS'), show: (this.navigation.getParamValue('posts.points.showFiled', true) && true), displayInList: true, type: 'textValue' },
    ];
  }

  format(fieldName: string, value: any) {
    if (fieldName.toLowerCase().indexOf('time') > -1) {
      return moment(value).format('YYYY-MM-DD HH:mm');
    } else if (fieldName.toLowerCase().indexOf('date') > -1) {
      return moment(value).format('YYYY-MM-DD');
    }
    return value;
  }

}
